import Cookies from "js-cookie";

const JWT_TOKEN = Cookies.get("jwt_token");
const GET_LOCALSTORAGE_JWT = (key) => JSON.parse(localStorage.getItem(key));

export { JWT_TOKEN, GET_LOCALSTORAGE_JWT };

